export default __webpack_public_path__ + "static/media/aboutmeicon.32ea74a5.svg";